import React, { useState } from 'react';
import { Lock, Loader2 } from 'lucide-react';
import { api } from '../lib/api';

export default function AdminLogin({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await api.post('/admin/login', { username, password });
      localStorage.setItem('intexso_admin_token', res.data.token);
      onLogin();
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F6F7F9] flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-[0_14px_40px_rgba(17,24,39,0.12)] p-8 sm:p-10">
        <div className="text-center">
          <div className="mx-auto h-14 w-14 rounded-2xl bg-[#26247B] flex items-center justify-center">
            <Lock className="h-7 w-7 text-white" />
          </div>
          <h1 className="mt-5 text-2xl font-extrabold text-[#26247B]">Intexso CMS</h1>
          <p className="mt-1.5 text-sm text-black/60">Sign in to manage your website content</p>
        </div>

        <form onSubmit={handleSubmit} className="mt-8 space-y-5">
          <div>
            <label className="text-sm font-semibold text-black block mb-1.5">Username</label>
            <input
              data-testid="admin-login-username-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="w-full h-12 rounded-lg bg-white border border-[#E6E8EE] px-4 text-sm focus:outline-none focus:ring-2 focus:ring-[#26247B]"
            />
          </div>
          <div>
            <label className="text-sm font-semibold text-black block mb-1.5">Password</label>
            <input
              data-testid="admin-login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full h-12 rounded-lg bg-white border border-[#E6E8EE] px-4 text-sm focus:outline-none focus:ring-2 focus:ring-[#26247B]"
            />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="text-sm font-semibold text-red-600 bg-red-50 border border-red-200 rounded-lg px-4 py-3">{error}</p>
          )}
          <button
            type="submit"
            data-testid="admin-login-submit-button"
            disabled={loading}
            className="w-full h-12 rounded-lg bg-[#26247B] text-white font-bold flex items-center justify-center gap-2 transition-colors duration-200 hover:bg-[#1f1d66] disabled:opacity-60"
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
